import { Link } from '../../components/Link'
import React from 'react'

export const Breadcrumb = ({ title }) => {
  return (
    <section id="breadcrumbs" className="breadcrumbs">
      <div className="container">
        <div className="d-flex justify-content-between align-items-center">
          <div className="d-flex justify-content-between align-items-center">
            <h2 className="m-1">{title}</h2>
          </div>

          <ol>
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>{title}</li>
          </ol>
        </div>
      </div>
    </section>
  )
}
